"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  var norobots = document.createElement("meta");
  norobots.name = "robots";
  norobots.content = "noindex";
  document.getElementsByTagName("head")[0].appendChild(norobots);
};

exports.default = _default;